import { styled } from '../../Utilities';
import { DocumentCardLogoBase } from './DocumentCardLogo.base';
import { getStyles } from './DocumentCardLogo.styles';
export var DocumentCardLogo = styled(DocumentCardLogoBase, getStyles, undefined, {
  scope: 'DocumentCardLogo'
});